<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import AlertError from "@/components/alert_error";
import { VueContentLoading } from "vue-content-loading";
import QrCodeCard from "@/components/qr_code_card";

export default {
  page: {
    title: "أستمارة قطع الاراضي",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError, VueContentLoading, QrCodeCard },
  data() {
    return {
      title: "تفاصيل الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/",
        },
        {
          text: "قطع الاراضي - الجرحى",
          href: "/plots-of-land-2/injuries",
        },
        {
          text: "التفاصيل",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      loadingContent: true,
      injury: null,
      qrCodeContent: null,
      showAlert: false,
    };
  },
  computed: {
    ...mapGetters("plotsOfLand2Injury", ["getInjury"]),
  },
  methods: {
    ...mapActions("plotsOfLand2Injury", ["get"]),
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    fetch() {
      this.get(this.id)
        .then(() => {
          this.injury = this.getInjury;
          this.loadingContent = false;

          this.qrCodeContent = JSON.stringify({
            Id: this.injury.qr_id,
            fullName: this.injury.full_name,
            date: this.injury.created_at,
          });
        })
        .catch((error) => {
          this.handleError(error);
          this.loadingContent = false;
        });
    },
    // get child scores by id for family scores.
    childHasScore(id, field) {
      return this.childGetScore(id, field) != null;
    },
    childGetScore(id, field) {
      let score = this.injury.scores.family.housemates.find((p) => p.id == id);
      if (score != null) {
        return score[field];
      }
      return null;
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    // setTimeout(() => {
    //   this.loadingContent = false;
    // }, 1000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

        <div class="card">
          <div v-if="!loadingContent" class="card-body">
            <hr class="hr-title" />
            <div class="break-title">
              <h5 class="mb-2">معلومات الجريح الاساسية</h5>
            </div>
            <div class="row about-list mb-2">
              <h4>الاسم : {{ injury.personal_info.full_name }}</h4>
              <div class="col-md-4">
                <div class="media">
                  <label>اللقب :</label>
                  <p>{{ injury.personal_info.family_name }}</p>
                </div>
                <div class="media">
                  <label>اسم الام الثلاثي :</label>
                  <p>{{ injury.personal_info.mother_name }}</p>
                </div>
                <div class="media">
                  <label>تاريخ التولد :</label>
                  <p>{{ injury.personal_info.birth_date }}</p>
                </div>
                <div class="media">
                  <label>الجنس :</label>
                  <p>
                    {{ injury.personal_info.gender.title }}
                  </p>
                </div>
                <div class="media">
                  <label>تاريخ التعيين :</label>
                  <p>
                    {{ injury.date_hire }}
                    <span class="degree-display">{{
                      injury.scores.basic.years_services
                    }}</span>
                  </p>
                </div>
                <div class="media" v-if="injury.personal_info.nationality_number != null">
                  <label>رقم البطاقة الوطنية :</label>
                  <p>{{ injury.personal_info.nationality_number }}</p>
                </div>
                <div class="media" v-else>
                  <label>هوية الاحول المدنية :</label>
                  <p>{{ injury.personal_info.national_id_number }}</p>
                </div>
                <div class="media">
                  <label>نسبة العجز :</label>
                  <p>
                    {{ injury.wound_info.disability_ratio }}
                    <span class="degree-display">{{
                      injury.scores.basic.disability_ratio
                    }}</span>
                  </p>
                </div>
                <div class="media">
                  <label>المنح الحكومية :</label>
                  <p>
                    {{ injury.grants.map((x) => x.title).join(", ") }}
                    <span class="degree-display">{{ injury.scores.basic.grants }}</span>
                  </p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>التحصيل الدراسي :</label>
                  <p>{{ injury.personal_info.certificate.title }}</p>
                </div>
                <div class="media">
                  <label>التخصص الدراسي :</label>
                  <p>{{ injury.personal_info.specialization }}</p>
                </div>
                <div class="media">
                  <label>رقم الهاتف 1 :</label>
                  <p>{{ injury.personal_info.phone }}</p>
                </div>
                <div class="media">
                  <label>رقم الهاتف 2 :</label>
                  <p>{{ injury.personal_info.phone2 }}</p>
                </div>
                <div class="media">
                  <label>التشكيل :</label>
                  <p>{{ injury.dept }}</p>
                </div>
                <div class="media">
                  <label>هل انت من ذوي الشهداء :</label>
                  <p>
                    {{ injury.have_martyr > 0 ? "نعم" : "لا" }}
                    <span class="degree-display">{{
                      injury.scores.basic.have_martyr
                    }}</span>
                  </p>
                </div>
                <div class="media">
                  <label>هل انت مستمر بالخدمة :</label>
                  <p>{{ injury.still_in_service ? "نعم" : "لا" }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>الحالة الاجتماعية :</label>
                  <p>
                    {{ injury.personal_info.marital_status.title }}
                    <span class="degree-display">{{
                      injury.scores.basic.marital_status
                    }}</span>
                  </p>
                </div>
                <div class="media">
                  <label>الوضع الصحي :</label>
                  <p>
                    {{
                      injury.health_statuses.length > 0
                        ? injury.health_statuses.map((x) => x.title).join(", ")
                        : "لا يوجد"
                    }}
                    <span class="degree-display">{{
                      injury.scores.basic.health_statuses
                    }}</span>
                  </p>
                </div>
                <div class="media">
                  <label>تاريخ الاصابة :</label>
                  <p>{{ injury.wound_info.date_wound }}</p>
                </div>
                <div class="media">
                  <label>محل الحادث :</label>
                  <p>{{ injury.wound_info.place_wound }}</p>
                </div>
                <div class="media" v-if="injury.have_martyr > 0">
                  <label>فئة الشهيد :</label>
                  <p>{{ injury.martyr_category.title }}</p>
                </div>
                <div class="media" v-if="!injury.still_in_service">
                  <label>الرقم التقاعدي :</label>
                  <p>{{ injury.retirement_number }}</p>
                </div>
                <div class="media" v-else>
                  <label>رقم بطاقة المهندس :</label>
                  <p>{{ injury.q_card_number }}</p>
                </div>
              </div>
            </div>
            <hr class="hr-title" />
            <div class="break-title">
              <h5 class="mb-2">عنوان السكن للجريح</h5>
            </div>
            <div class="row about-list mb-2">
              <div class="col-md-4">
                <div class="media">
                  <label>المحافظة :</label>
                  <p>{{ injury.address.city.title }}</p>
                </div>
                <div class="media">
                  <label>محلة :</label>
                  <p>{{ injury.address.mahla }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>القضاء :</label>
                  <p>{{ injury.address.district }}</p>
                </div>
                <div class="media">
                  <label>زقاق :</label>
                  <p>{{ injury.address.zqaq }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>الناحية :</label>
                  <p>{{ injury.address.region }}</p>
                </div>
                <div class="media">
                  <label>دار :</label>
                  <p>{{ injury.address.dar }}</p>
                </div>
              </div>
            </div>
            <hr class="hr-title" />
            <div class="break-title">
              <h5 class="mb-2">معلومات الملكية للجريح</h5>
            </div>
            <div class="row about-list">
              <div class="col-md-4">
                <div class="media">
                  <label>هل تمتلك عقار بأسمك :</label>
                  <p>
                    {{ injury.housing_info.real_estate.title }}
                    <span class="degree-display">{{
                      injury.scores.housing.real_estate
                    }}</span>
                  </p>
                </div>
                <div class="media">
                  <label>نوع السكن :</label>
                  <p>
                    {{ injury.housing_info.accommodation.title }}
                    <span class="degree-display">{{
                      injury.scores.housing.accommodation
                    }}</span>
                  </p>
                </div>
                <div class="media">
                  <label>خصوصية السكن :</label>
                  <p>
                    {{ injury.housing_info.address_privacy.title }}
                    <span class="degree-display">{{
                      injury.scores.housing.address_privacy
                    }}</span>
                  </p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>نوع البناء :</label>
                  <p>
                    {{ injury.housing_info.build_material_type.title }}
                    <span class="degree-display">{{
                      injury.scores.housing.build_material_type
                    }}</span>
                  </p>
                </div>
                <div class="media">
                  <label>حالة البناء :</label>
                  <p>
                    {{ injury.housing_info.building_condition.title }}
                    <span class="degree-display">{{
                      injury.scores.housing.building_condition
                    }}</span>
                  </p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>مساحة السكن :</label>
                  <p>
                    {{ injury.housing_info.area }}
                    <span class="degree-display">{{ injury.scores.housing.area }}</span>
                  </p>
                </div>
                <div class="media">
                  <label>عدد الطوابق :</label>
                  <p>{{ injury.housing_info.floors_number }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">مواصفات الوحدة السكنية</h5></div>
            <div class="row about-list">
              <div class="col-md-4">
                <div class="media">
                  <label>الوحدة السكنية :</label>
                  <p>{{ injury.housing.unit.title }}</p>
                </div>
                <div class="media">
                  <label>المحافظة :</label>
                  <p>{{ injury.housing.city.title }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>نوع الوحدة السكنية :</label>
                  <p>{{ injury.housing.unit_type.title }}</p>
                </div>
                <!-- <div class="media">
                  <label>نمط الوحدة السكنية :</label>
                  <p>{{ injury.housing.build_style.title }}</p>
                </div> -->
              </div>
              <div class="col-md-4">
                <div class="media">
                  <label>مساحة الوحدة السكنية :</label>
                  <p>{{ injury.housing.unit_area.title }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات عائلة مقدم الطلب</h5></div>
            <div class="row about-list">
              <div class="col-md-12">
                <div role="tablist" class="tablist">
                  <b-card
                    v-for="(person, index) in injury.housemates"
                    :key="person"
                    no-body
                    class="mb-1 shadow-none"
                  >
                    <b-card-header header-tag="header" role="tab">
                      <h6 class="m-0">
                        <a
                          v-b-toggle="'accordion-' + index"
                          class="text-dark"
                          href="javascript: void(0);"
                          ><span>{{ index + 1 }}</span
                          >{{ person.personal_info.full_name }}</a
                        >
                        <!-- <a
                          v-if="person.basic_url"
                          :href="person.basic_url"
                          target="_blank"
                          class="float-end pt-1"
                        >
                          المرفقات الثبوتية
                        </a>
                        <a
                          v-if="person.health_url"
                          :href="person.health_url"
                          target="_blank"
                          class="float-end pt-1 mx-2"
                        >
                          مرفق الحالة الصحية
                        </a> -->
                      </h6>
                    </b-card-header>
                    <b-collapse
                      :id="'accordion-' + index"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>
                          <div class="row">
                            <div class="col-md-4">
                              <!-- <div class="media">
                                <label>اللقب :</label>
                                <p>{{ person.personal_info.family_name }}</p>
                              </div>
                              <div class="media">
                                <label>اسم الام الثلاثي :</label>
                                <p>{{ person.personal_info.mother_name }}</p>
                              </div>
                              <div class="media">
                                <label>تاريخ التولد :</label>
                                <p>
                                  {{ person.personal_info.birth_date }}
                                  <span
                                    class="degree-display"
                                    v-if="childHasScore(person.id, 'old')"
                                    >{{ childGetScore(person.id, "old") }}</span
                                  >
                                </p>
                              </div> -->
                              <div class="media">
                                <label>الجنس :</label>
                                <p>{{ person.personal_info.gender.title }}</p>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <!-- <div class="media">
                                <label>الحالة الاجتماعية :</label>
                                <p>{{ person.personal_info.marital_status.title }}</p>
                              </div>
                              <div class="media">
                                <label>التحصيل الدراسي :</label>
                                <p>{{ person.personal_info.certificate.title }}</p>
                              </div> -->
                              <div class="media">
                                <label>صلة القرابة من الجريح :</label>
                                <p>{{ person.relation_relative.title }}</p>
                              </div>
                            </div>
                            <!-- <div class="col-md-4">
                              <div class="media">
                                <label>هل تمتلك عقار بأسمك :</label>
                                <p>{{ person.real_estate.title }}</p>
                              </div>
                              <div class="media">
                                <label>الوضع الصحي :</label>
                                <p>
                                  {{
                                    person.health_statuses.map((x) => x.title).join(", ")
                                  }}
                                  <span
                                    class="degree-display"
                                    v-if="childHasScore(person.id, 'health')"
                                    >{{ childGetScore(person.id, "health") }}</span
                                  >
                                </p>
                              </div>
                              <div class="media">
                                <label>العمل :</label>
                                <p>
                                  {{ person.job.title }}
                                  <span
                                    class="degree-display"
                                    v-if="childHasScore(person.id, 'work')"
                                    >{{ childGetScore(person.id, "work") }}</span
                                  >
                                </p>
                              </div>
                              <div v-if="person.job.id == 3" class="media">
                                <label>مكان العمل :</label>
                                <p>{{ person.job_title }}</p>
                              </div>
                            </div> -->
                          </div>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">تنزيل المرفقات</h5></div>
            <div class="row about-list">
              <div class="col-md-6 d-grid">
                <a :href="injury.basic_url" target="_blank">
                  <b-button
                    :disabled="!injury.basic_url"
                    variant="primary"
                    type="button"
                    class="mb-2 w-100"
                    >المرفقات الثبوتية</b-button
                  >
                </a>
                <!-- <a :href="injury.health_url" target="_blank">
                  <b-button
                    :disabled="!injury.health_url"
                    variant="primary"
                    type="button"
                    class="mb-2 w-100"
                    >مرفق الحالة الصحية</b-button
                  >
                </a> -->
                <a :href="injury.wound_url" target="_blank">
                  <b-button
                    :disabled="!injury.wound_url"
                    variant="primary"
                    type="button"
                    class="mb-2 w-100"
                    >تاييد نسبة العجز</b-button
                  >
                </a>
                <a :href="injury.martyr_url" target="_blank">
                  <b-button
                    :disabled="!injury.martyr_url"
                    variant="primary"
                    type="button"
                    class="mb-2 w-100"
                    >تاييد ذوي الشهداء</b-button
                  >
                </a>

                <p class="text-center">
                  <span class="mx-3">درجة السكن : {{ injury.scores.housing.total }}</span>
                  <span class="mx-3"
                    >الدرجة الشخصية : {{ injury.scores.basic.total }}</span
                  >
                  <!-- <span class="mx-3"
                    >درجة العائلة : {{ injury.scores.family.total }}</span
                  > -->
                  <span class="mx-3">المجموع : {{ injury.scores.total }}</span>
                  <span class="mx-3">النسبة المئوية : {{ injury.scores.avg }}</span>
                  <span class="mx-3">النسبة المئوية X 2 : {{ injury.scores.avg2 }}</span>
                  <span class="mx-3">النسبة المئوية X 3 : {{ injury.scores.avg3 }}</span>
                </p>
              </div>
              <div class="col-md-6">
                <QrCodeCard
                  title="استمارة قطع الاراضي"
                  :fullName="this.injury.personal_info.full_name"
                  :date="this.injury.created_at"
                  :Id="this.injury.qr_id"
                  :qrCodeContent="this.qrCodeContent"
                ></QrCodeCard>
              </div>
            </div>
            <div class="mt-3">
              <hr />
              <b-button
                class=""
                type="button"
                to="/plots-of-land-2/injuries"
                variant="secondary"
                >رجوع</b-button
              >
            </div>
          </div>

          <!-- loading content -->
          <div v-else>
            <vue-content-loading :rtl="true" :width="400" :height="110">
              <rect x="85" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="275" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="6" y="15" rx="1" ry="1" width="194" height="2" />
              <rect x="200" y="16" rx="1" ry="1" width="194" height="1" />

              <rect x="10" y="25" rx="1" ry="1" width="50" height="5" />
              <rect x="340" y="25" rx="1" ry="1" width="50" height="5" />

              <rect x="10" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="40" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="49" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="54" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="63" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="68" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="77" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="82" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="91" rx="1" ry="1" width="380" height="1" />
              <circle cx="340" cy="100" r="1" />
              <circle cx="350" cy="100" r="1" />
              <circle cx="363" cy="100" r="4" />
              <circle cx="376" cy="100" r="1" />
              <circle cx="386" cy="100" r="1" />
            </vue-content-loading>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
